import styled from '@emotion/styled';
import { StyledProps, Theme } from './Nav.types';
import { variant } from 'styled-system';
import css from '@styled-system/css';

export const Nav = styled.nav<StyledProps, Theme>`
  ${css({
    width: '100%',
    height: '64px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  })}
  ${variant({
    variants: {
      website: {
        bg: 'var(--color-plum)',
      },
      white: {
        bg: 'var(--color-neutral-0)',
      },
      light: {
        bg: 'var(--color-dusty-pink-30)',
      },
      dark: {
        bg: 'var(--color-smoke)',
      },
    },
  })}
`;

export default Nav;
